import Axios from 'axios';

const host = process.env.VUE_APP_URL_API;

export default async hash => {
  try {
    return await Axios.get(`${host}/checkout/check-renewal/${hash}`);
  } catch (error) {
    throw new Error(error?.response?.data?.error?.message);
  }
};
